// extracted by mini-css-extract-plugin
export default {"created":"CPsF","visible":"_2SaN","alt":"_1UoD"};